import React from 'react';

import {   Row, Col, Button } from 'antd';

import axios from '../util/Api'

import { setDisconnectMachineId, getLanguage} from "../util/Toolbox";
import picto_home             from './assets/home/picto_home.png';

import iconeHeader from './assets/analyseTraitement/picto_traitement.svg';
import goutte_eau_header from './assets/analyseFormulaire/goutte_eau_header.svg';

import './css/navBar.css';

import ALGICIDE from './assets/analyseTraitement/ALGICIDE.svg';
import ANTI_CALCAIRE from './assets/analyseTraitement/ANTI_CALCAIRE.svg';
import BROME from './assets/analyseTraitement/BROME.svg';
import CHLORE_CHOC from './assets/analyseTraitement/CHLORE_CHOC.svg';
import CHLORE from './assets/analyseTraitement/CHLORE.svg';
import CHLORIT from './assets/analyseTraitement/CHLORIT.svg';
import CLARIFIANT from './assets/analyseTraitement/CLARIFIANT.svg';
import O_ACTIVE from './assets/analyseTraitement/O_ACTIVE.svg';
import PH_MOINS from './assets/analyseTraitement/PH_MOINS.svg';
import PH_PLUS from './assets/analyseTraitement/PH_PLUS.svg';
import TAC_MOINS from './assets/analyseTraitement/TAC_MOINS.svg';
import TAC_PLUS from './assets/analyseTraitement/TAC_PLUS.svg';
import TH from './assets/analyseTraitement/TH.svg';
import STABILISANT from './assets/analyseTraitement/STABILISANT.svg';

import './css/analyseTraitement.css';


 class AnalyseTraitement extends React.Component {

  constructor(props) {

    super(props);

    this.state = {

      traitement_LIST : [],
      GUID_Analyse : '',
      IndexCurrentEtape : 0,
      language : getLanguage()

    }

  }


  async componentDidMount() {

    const search  = window.location.search;
    const params  = new URLSearchParams(search);
    const analyse  = params.get('analyse');



    // Appel API
    this.loadAnalyse(analyse);

  }


  loadAnalyse(analyse){

    axios.get(`analyse/${analyse}/analyseItem`,
    ).then(({data}) => {
      console.log(data);

      if(data.success == 'success'){
          this.setState({IndexCurrentEtape : data.result.IndexCurrentEtape,  GUID_Analyse : data.result.GUID_Analyse, traitement_LIST : data.result.traitement_LIST });
      }

    }).catch(function (error) {
      console.log("Error****:", error.message);
    });

  }


  handleChangeValue = (dataType, value) => {
    console.log('handleChangeValue')
    this.setState({[dataType]: value});
  }


  getImageTraitement(pe_libelle){

    switch (pe_libelle) {

      case 'TAC_PLUS':
        return TAC_PLUS;
        break;

      case 'ALGICIDE':
        return ALGICIDE;
        break;

      case 'ANTI_CALCAIRE':
        return ANTI_CALCAIRE;
        break;

      case 'BROME':
        return BROME;
        break;

      case 'CHLORE_CHOC':
        return CHLORE_CHOC;
        break;

      case 'CHLORE':
        return CHLORE;
        break;

      case 'CHLORIT':
        return CHLORIT;
        break;

      case 'CLARIFIANT':
        return CLARIFIANT;
        break;

      case 'O_ACTIVE':
        return O_ACTIVE;
        break;

      case 'PH_MOINS':
        return PH_MOINS;
        break;

      case 'PH_PLUS':
        return PH_PLUS;
        break;

      case 'TAC_MOINS':
        return TAC_MOINS;
        break;

      case 'TAC_PLUS':
        return TAC_PLUS;
        break;

      case 'TH':
        return TH;
        break;

      case 'STABILISANT':
        return STABILISANT;
        break;


      default:

    }


  }


  validationTraitementCell = (IDFamille, type) => {

      for (var i = 0; i < this.state.traitement_LIST.length; i++) {

        if(this.state.traitement_LIST[i].IDFamille == IDFamille){

            if(i == this.state.IndexCurrentEtape){
              window.location.href= '/analyseTraitementFamille?analyse='+ this.state.GUID_Analyse+ '&id='+IDFamille;
            }
        }
      }
  };


  retourVersResumeAnalyse = () =>{

    window.location.href= '/analyse?analyse='+ this.state.GUID_Analyse;
  }


  retourVersStoreLocator = () =>{

    window.open('https://www.hydrapro.fr/app/uploads/storelocator0106/wordpress/hydrapro/index.html', '_blank');

  }



  render() {


      return (

        <div className = "wrapper_analyse">

          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

          <nav>
                  <ul>
                      <li><a   href = "/"><img loading="lazy" src={picto_home} width ="180px"/></a></li>
                      <li><a  style = {{marginTop : 10}} href="/forms">Analyse</a></li>
                      <li><a href="/simulateur">Calcul du volume</a></li>
                      <li><a href="/historique">Ordonnances</a></li>
                      <li> <span onClick={setDisconnectMachineId}> <a href="#">Se deconnecter</a> </span>  </li>
                  </ul>
            </nav>





          <div className = "wrapper_analyse_header">

            <img loading="lazy"  src={iconeHeader} />

            <p className = "wrapper_analyse_header_Title">Traitement</p>

            <div className = "header_image_goutte">
              <img loading="lazy" src={goutte_eau_header} />
            </div>

          </div>

          <div className= "bassin_wrapper">

          <Row style = {{marginTop: 20}} gutter={[8, 0]}>
          {
              this.state.traitement_LIST.map((item, i) => (

                <Col xl={2} lg={3} md={6}  sm={8} xs={8} style={{ cursor: 'pointer'}} className="gutter-row" span={8} onClick= {this.validationTraitementCell.bind(this,item.IDFamille)}>
                  <div style={{ opacity :  i == this.state.IndexCurrentEtape ? 1 : 0.5 }} className= "traitementAnalyse_cell">
                    <img loading="lazy" width="100%" height="100%" src={this.getImageTraitement(item.LibelleImage)} />
                    <p style = {{marginTop:0}}>{'Etape ' + (i+ 1)}</p>
                  </div>
                </Col>
            ))
          }
          </Row>


          <div style = {{marginTop:20, textAlign : 'center'} }>
              <Button className = 'buttonFormStyle' onClick = {this.retourVersStoreLocator }  size={"large"} style={{width: "250px", fontWeight:600, paddingLeft:40, paddingRight:40, marginBottom: 16, backgroundColor: '#FFDD00', color:'#2B4570'}}>Trouver un revendeur</Button>
          </div>

          <div style = {{marginTop:20, marginBottom:90, textAlign : 'center'} }>
              <Button className = 'buttonFormStyle' onClick = {this.retourVersResumeAnalyse}  size={"large"} style={{width: "250px", fontWeight:600, paddingLeft:40, paddingRight:40, marginBottom: 16,  backgroundColor: '#FFDD00', color:'#2B4570'}}>Retour à l'analyse</Button>
          </div>




        </div>



      </div>

      )

    };
}



export default AnalyseTraitement;
